<div class="card p-3 h-100">
	<div class="dashboard-metric m-auto">
		<highcharts-chart
		#chart
		[constructorType]="chartConstructor"
		[options]="chartOptions"
		[(update)]="updateFlag"
		[oneToOne]="oneToOneFlag"
		class="chart"
		style="width: 40em; height: 20em ; display: block;"/>
	</div>
</div>
